import { Injectable } from '@angular/core';
import { Chooser } from '@awesome-cordova-plugins/chooser/ngx';
import { Observable } from 'rxjs';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { ActionSheetController } from '@ionic/angular';
@Injectable({
  providedIn: 'root'
})
export class ImagingService {

  constructor(
    private chooser: Chooser, 
    public actionSheetController: ActionSheetController
    ) { }

  async fileActionSheet() {
    return new Promise(async (resolve, reject) => {
      const actionSheet = await this.actionSheetController.create({
        header: 'Choose an action',
        cssClass: 'my-custom-class',
        buttons: [{
          text: 'Open Camera',
          icon: 'camera',
          handler: () => {
            this.getSourceImage('DataUrl').then((file) => resolve({
              img: file,
              fileType: 'image'
            }));
          }
        }, {
          text: 'Choose From Gallery',
          icon: 'images',
          handler: () => {
            this.getGalleryImage('DataUrl').then((file) => resolve({
              img: file,
              fileType: 'image'
            }));;
          }
        }, {
          text: 'Choose From Library',
          icon: 'folder',
          handler: () => {
            this.attachFile().then((file) => resolve({
              img: file,
              fileType: 'pdf'
            }));;
          }
        }, {
          text: 'Cancel',
          icon: 'close',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        }]
      });
      await actionSheet.present();
    });
  }


  getSourceImage(result) {
    return new Promise(async (resolve, reject) => {
      try {
        const image = await Camera.getPhoto({
          quality: 50,
          allowEditing: false,
          source: CameraSource.Camera,
          resultType: CameraResultType.DataUrl,
          width: 1000, 
          correctOrientation: true
        });

        const imageUrl = image.dataUrl;
        resolve(imageUrl);
      } catch (e) {
        reject(false);
      }
    });


  }

  async getGalleryImages() {

    return new Promise(async (resolve, reject) => {
      try {
        const image = await Camera.pickImages({          
          quality: 50,
          width: 1000,      
          correctOrientation: true
        });
        const imageUrl = image.photos;
        
        resolve(imageUrl);
      } catch (e) {
        reject(e);
      }
    });

  }
async getGalleryBlob(photo) {
  let blob = await fetch(photo).then(r => r.blob());  
      //console.log(blob); 
      return blob;
      
  };



  async getPhoto() {

    return new Promise(async (resolve, reject) => {
      try {
        const image = await Camera.getPhoto({
          quality: 80,
          allowEditing: false,
          source: CameraSource.Camera,
          resultType: CameraResultType.DataUrl
        });
        const imageUrl = image.dataUrl;
        resolve(imageUrl);
      } catch (e) {
        reject(e);
      }
    });

  }

  getGalleryImage(result) { 
    return new Promise(async (resolve, reject) => {
      try {
        const image = await Camera.getPhoto({
          quality: 80,
          allowEditing: false,
          source: CameraSource.Photos,
          resultType: CameraResultType.DataUrl
        });

        const imageUrl = image.dataUrl;
        resolve(imageUrl);
      } catch (e) {
        reject(e);
      }
    });

  }

  attachFile() {
    return new Promise(async (resolve, reject) => {
      this.chooser.getFile('application/pdf')
        .then(file => {
          if (file) {
            resolve(file.dataURI);
          } else {
            //console.log(file ? file.name : 'canceled');
           reject('Error ');
          }
        }, err => {
          reject('Error ');
        })
        .catch((error: any) => reject('CordovaCamera: ' + error));
    });

  }


}

